import init from './App'

init()